<template>
  <div class="formSearchInput" v-click-outside="closeList">
    <div class="formSearchInput__inner">
      <form-field
        :value="value"
        name="input"
        type="text"
        :label="
          $device.isMobile ? 'np. marka lub model' : 'szukaj np. marka lub model drukarki/tonerów'
        "
        class="formSearchInput__input"
        @input="$emit('input', $event)"
        @click="openList"
      />
      <v-button class="formSearchInput__button" has-html theme="orange" @click="$emit('click')">
        <span class="icon-search" />
      </v-button>
    </div>
    <div
      ref="searchDropdown"
      v-show="openDropdown && autocompleteItems.length"
      class="formSearchInput__autocomplete prettyScrollbar"
    >
      <div class="formSearchInput__autocompleteInner">
        <ul :key="index" v-for="(item, index) in autocompleteItems">
          <li :key="childIndex" v-for="(child, childIndex) in item">
            <h5 v-if="child.title">
              {{ child.title }}
            </h5>
            <nuxt-link :to="child.url" @click.native="select(child.data)" v-else>
              {{ child.data.text }}
            </nuxt-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import VButton from '../VButton';
import FormField from './FormField';

export default {
  name: 'FormSearchInput',
  components: { VButton, FormField },
  props: {
    value: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: Boolean,
      default: false,
    },
    autocompleteItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      openDropdown: false,
    };
  },
  methods: {
    closeList() {
      const dropdown = this.$refs.searchDropdown;
      if (!dropdown) return;
      dropdown.style.maxHeight = '0px';
      this.openDropdown = false;
    },
    openList() {
      if (!this.autocomplete) return;
      const dropdown = this.$refs.searchDropdown;
      if (!dropdown) return;
      dropdown.style.maxHeight = `300px`;

      this.openDropdown = true;
    },
    select(data) {
      this.$emit('select', data);
      this.closeList();
    },
  },
};
</script>

<style lang="scss">
.formSearchInput {
  position: relative;
  &__inner {
    position: relative;
  }

  &__input {
    padding-top: 0 !important;

    input {
      padding-right: 6rem !important;
    }
  }

  &__button {
    position: absolute;
    z-index: 20;
    right: 3px;
    top: 50%;
    transform: translateY(-50%);
    height: calc(100% - 6px);
    padding-left: 0;
    padding-right: 0;
    width: 4.2rem;
  }

  &__autocomplete {
    position: absolute;
    left: 0;
    max-height: 0;
    top: 100%;
    width: 100%;
    z-index: $zIndexLayer;
    overflow: scroll;
    background-color: $cWhite;
    border: 1px solid $cAddLight;
    border-radius: 0 4px 4px 0;
    transition: max-height $tr;
  }

  &__autocompleteInner {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
    padding-top: 2rem;

    h5 {
      font-size: 1.4rem;
      line-height: 1.8rem;
      font-weight: 700;
      margin-bottom: 1.6rem;
    }

    ul {
      margin-bottom: 1.6rem;

      &:last-child {
        margin-bottom: 0;
      }
    }

    a {
      margin-bottom: 0.9rem;
      display: flex;
      align-content: center;
      font-size: 1.4rem;
      line-height: 1.8rem;
      transition: color $tr;

      &:hover {
        color: $cSec;
      }
    }
  }
}
</style>
